module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-wrapper"
  }, [_c('block', {
    attrs: {
      "data": _vm.pcXfqfGoodsAdv,
      "url": 'recommend-goods?type=5'
    }
  }), _vm._v(" "), _c('block', {
    attrs: {
      "data": _vm.pcZyypGoodsAdv,
      "url": 'recommend-goods?type=2'
    }
  }), _vm._v(" "), _c('block', {
    attrs: {
      "data": _vm.pcHmdjkGoodsAdv,
      "url": _vm.pcHmdjkGoodsAdv.advList[0].url || ''
    }
  }), _vm._v(" "), _c('block', {
    attrs: {
      "data": _vm.pcZlyyGoodsAdv
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0792ce9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/middle-ads/index.vue
// module id = 1522
// module chunks = 1